import './Footer.css';
import { connect } from 'react-redux';
import { LEGAL_LINK, TERMS_LINK, ESA_LINK } from '../../utils/config';

import { LoginState } from '@acri-tools/react-tools/redux/reducers/loginReducer';
import { GDPRState, setGDPR } from '@acri-tools/react-tools/redux/reducers/gdprReducer';
import { RTReduxAction } from '@acri-tools/react-tools/redux/reducers';
import { ReduxState } from '../../redux';
import { Link } from 'react-router-dom';

const esaWhiteLogoFooter = '/assets/esa_white_logo_100.webp';

interface Props {
    login: LoginState,
    setGDPR: RTReduxAction<GDPRState>
}

const Footer = ({ setGDPR }: Props) => {
    return (
        <footer id="footer">
            <div className="main-footer">

                {/* Left Section: About */}
                <section className="footer-container">
                    <h2 className="footer-title">4DBALTDYN</h2>
                    <p className="footer-description">
                        The 4DBALTIC-SEA EXPRO+ Project is an innovative initiative enhancing our understanding of the Baltic Sea’s
                        ecosystem through cutting-edge technology and interdisciplinary collaboration.
                        <br /><br />
                        Our mission is to provide comprehensive 4D reconstructions of the Baltic Sea's environment,
                        integrating Earth Observation data with advanced modelling to support sustainable environmental policy.
                    </p>
                    <a href={ESA_LINK} target="_blank" rel="noopener noreferrer">
                        <img className="footer-logo-image" alt="ESA Logo" src={esaWhiteLogoFooter} loading="lazy" width="100"
                            height="40" />
                    </a>
                </section>

                {/* Center Section: Navigation */}
                <nav className="footer-container" aria-label="Footer Main Navigation">
                    <h2 className="footer-title">Navigation</h2>
                    <ul className="footer-description">
                        <li><Link className="footer-navigation-link" to="/">Home</Link></li>
                        <li><Link className="footer-navigation-link" to="/project">Project</Link></li>
                        <li><Link className="footer-navigation-link" to="/team">Team</Link></li>
                        <li><Link className="footer-navigation-link" to="/news">Project News & Blog</Link></li>
                        <li><Link className="footer-navigation-link" to="/contact">Contact</Link></li>
                    </ul>
                </nav>

                {/* Right Section: Subpages */}
                <section className="footer-container">
                    <h2 className="footer-title">Project</h2>
                    <ul className="footer-description">
                        <li><Link className="footer-navigation-link" to="/project/objectives">Objectives</Link></li>
                        <li><Link className="footer-navigation-link" to="/project/tasks">Tasks</Link></li>
                        <li><Link className="footer-navigation-link" to="/project/outcomes-and-deliverables">Deliverables</Link></li>
                    </ul>

                    <h2 className="footer-title" style={{ marginTop: "20px" }}>Team</h2>
                    <ul className="footer-description">
                        <li><Link className="footer-navigation-link" to="/team/collaborators">Collaborators</Link></li>
                        <li><Link className="footer-navigation-link" to="/team/consortium">Consortium</Link></li>
                    </ul>
                </section>
            </div>

            {/* Sub-Footer: Legal and GDPR */}
            <div className="sub-footer">
                <div className="rights">
                    <div className="rights-text">
                        © ACRI-ST {new Date().getUTCFullYear()}. All Rights Reserved.
                    </div>
                    <div className="rights-links">
                        <a className="footer-navigation-link" href={LEGAL_LINK} target="_blank" rel="noopener noreferrer nofollow">Legal Notice</a>
                        <i className="bullet fas fa-circle" />
                        <a className="footer-navigation-link" href={TERMS_LINK} target="_blank" rel="noopener noreferrer nofollow">General Conditions</a>
                        <i className="bullet fas fa-circle" />
                        <button
                            id="gdpr-button"
                            name="gdpr-button"
                            className="footer-navigation-link"
                            onClick={() => setGDPR({ open: true })}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                margin: 0,
                                color: 'inherit',
                                cursor: 'pointer'
                            }}
                            aria-label="Open GDPR preferences"
                        >
                            GDPR
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default connect(({ login }: ReduxState) => ({ login }), { setGDPR })(Footer);
